import { connect, useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { useState, useEffect, useCallback } from "react";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import { setApps } from "../../../../../store/slices/master/appSlice";
import ReactModal from "react-modal";
import {
  IDescriptionData,
  IDescriptionIndex,
} from "../../../../../models/master/descriptions";
import DescriptionCreate from "./descriptionCreate";
import {
  deleteDescription,
  getAllDescription,
  getDescription,
} from "../../../../../action/masters/descriptionActionCreator";
import LoaderSpinner from "../../../../../common-components/loader";
import DescriptionEdit from "./descriptionEdit";
import { baseURL } from "../../../../../constants/commonConstants";
import FloatingLabelDropDown from "../../../../../common-components/floatingdropdown";
import { sortAlphabetically } from "../../../../../common-functions/commonFunctions";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";
import { getUserTypes } from "../../../../../action/common/commonActionCreator";

const DescriptionIndex = (props: IDescriptionIndex) => {
  const {
    getDescriptions,
    descriptions,
    getDescription,
    description,
    deleteDescription,
    userTypes,
    getUserTypes
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [selectedUserType, setSelectedUserType] = useState<number | null>(null);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getDescription(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteDescription(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllDescription(selectedUserType ?? undefined);
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllDescription = async (userType?:number) => {
    setIsLoading(true);
    try {
      await getDescriptions(userType);
    } finally {
      setIsLoading(false);
    }
  };

    const onUserTypeChange = useCallback( (e: any ) => {
      if(e.target.name == "userType")
      setSelectedUserType(e.target.value)
      getAllDescription(e.target.value)
    },[])
    
  useEffect(() => {
    getAllDescription();
    getUserTypes();
    return () => {
      dispatch(setApps([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Descriptions</h2>
          <div className="side-filter">
            <div className="justify-content-left">
            <FloatingLabelDropDown
            label=""
            placeholder="-Select UserType-"
            onChange={(e : any) => onUserTypeChange(e)}
            isMandatory={false}
            value={selectedUserType}
            name="userType"
            optionsList={sortAlphabetically(
              userTypes?.filter((type) => type.id !== UserTypes.Freshman)
            )}
          />
          </div>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={() => {
              handleCreateOpen();
            }}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-3">
          {isLoading ? (
            <LoaderSpinner />
          ) : descriptions && descriptions.length > 0 ? (
            descriptions.map((description: IDescriptionData) => {
              return (
                <li
                  className="admin-card w-100"
                  style={{
                    pointerEvents: !description.isActive ? "none" : "auto",
                    opacity: !description.isActive ? 0.5 : 1,
                  }}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(description.id ?? 0)}
                        data-bs-toggle="modal"
                        data-bs-target="#editpopup"
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <div className="btm">
                    <h2>{description.title}</h2>
                    <img
                      src={description.image ? baseURL + description.image : ""}
                      alt=""
                      className="mb-1"
                      style={{ width: "200px" }}
                    ></img>
                    <p className="text-wrap">{description.description}</p>
                    <p>{description.college}</p>
                  </div>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <DescriptionCreate
          setShowCreate={handleCreateClose}
          getAllDescription={() => getAllDescription(selectedUserType ?? undefined)}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <DescriptionEdit
            setShowEdit={handleEditClose}
            getAllDescription={() => getAllDescription(selectedUserType ?? undefined)}
            description={description}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getDescriptions: (userType?:number) => getAllDescription(userType),
  getDescription: (id: number) => getDescription(id),
  deleteDescription: (id: number, callBack: Function) => deleteDescription(id, callBack),
  getUserTypes: () => getUserTypes(),
};

function mapStateToProps(state: any) {
  return {
    descriptions: state.description.descriptions,
    description: state.description.description,
    userTypes: state.common.userTypes,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DescriptionIndex);
